






































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { WithdrawVerifyBillAPI } from "@/common/api/financeManage/withdrawVerifyBill";

import {getCommonList} from '@/common/config';

export const pageApiList = getPageAPIs(WithdrawVerifyBillAPI);

const defaultForm = {
  order_no: "", // 原支付单号
  bill_status: -1, // 交易对账状态 -1全部 0交易中 1交易成功 2交易失败 3对账错误
  type: "", // 类型 0全部  1预转账 2提现
  shop_id: '', // 店铺id
  shop_name : ''
};

// 类型 0全部  1预转账 2提现
const allBizType2ch: string[] = [
  "",
  "预转账",
  "提现",
];

//通联交易状态 0未知 1审核中 2交易中 3交易成功 4交易失败 5交易拒绝 6对账金额有误
const allIsStatus2ch: string[] = [
  "",
  "审核中",
  "交易中",
  "交易成功",
  "交易失败",
  "交易拒绝",
  "对账金额有误",
];

// 自有交易状态 0未知 1，转账中（提现中） 2，交易成功 3，转账失败（提现失败） 括号为提现状态 4驳回
const allOrderStatus2ch: string[] = [
  "",
  "转账中（提现中）",
  "交易成功",
  "转账失败（提现失败）",
  "驳回",
];

// 对账状态 0交易中 1交易成功 2交易失败 3对账错误
const allBillStatus2ch: string[] = [
  "交易中",
  "交易成功",
  "交易失败",
  "对账错误",
];


@Component({
  filters: {
    //对账类型
    showTypeName(type: number) {
      return allBizType2ch[type] || "未知";
    },
    //通联交易状态
    showIsStatusName(type: number) {
      return allIsStatus2ch[type] || "未知";
    },
    //自有交易状态
    showOrderStatusName(type: number) {
      return allOrderStatus2ch[type] || "未知";
    },
    //对账状态
    showBillStatusName(type: number) {
      return allBillStatus2ch[type] || "未知";
    },
  },
})
export default class MerchantWithdrawList extends Vue {
  private abnormalPayOrderListApi: any;

  private deepLoopUtil: any;

  private utilIns: any;
  private billTypeList: any[] = [...getCommonList(allBizType2ch, 1)];
  private billStatusList: any[] = [
    {
      label: "全部",
      value: -1,
    },
    {
      label: "交易中",
      value: 0,
    },
    {
      label: "交易成功",
      value: 1,
    },
    {
      label: "交易失败",
      value: 2,
    },
    {
      label: "对账错误",
      value: 3,
    },
  ];

  constructor() {
    super();
    this.abnormalPayOrderListApi = new WithdrawVerifyBillAPI();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };


    this.utilIns = new Util();

  }

  private form: any;

  private firstLoading: boolean = true;
  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    this.getTable();
  }

  private getTable(): void {
    this.abnormalPayOrderListApi.getList(
      this.getAbnormalPayOrderListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      },
      false
    );
  }

  private getAbnormalPayOrderListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const { order_no, bill_status,type,shop_id,shop_name } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};
    if (order_no) {
      outerParams.order_no = order_no;
    }

    if (typeof bill_status == "number") {
      outerParams.bill_status = bill_status;
    }

    if (typeof type == "number") {
      outerParams.type = type;
    }

    if (shop_id) {
      outerParams.shop_id = shop_id;
    }

    if (shop_name) {
      outerParams.shop_name = shop_name;
    }


    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      // outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const newData = {
      ...data,
    };

    return newData;
  }

  private dialogFormVisible: boolean = false;

  private abnormalOrderManualSetLoading: boolean = false;

  private withdrawManualState: number = 0;


  private handleWithdrawSetSuccess(queryInfo: any, state: number) {
    this.withdrawManualState = state;
    const params: any = {
      id: queryInfo.id,
      // state
    };

    this.withdrawManualSet(params);
  }

  private handleWithdrawSetFail(queryInfo: any, state: number) {
    this.withdrawManualState = state;
    const params: any = {
      id: queryInfo.id,
      // state
    };

    this.withdrawManualSet(params);
  }

  private withdrawManualSet(params: any) {
    this.abnormalOrderManualSetLoading = true;
    this.abnormalPayOrderListApi.abnormalOrderManualSetStatus(
      params,
      () => {
        this.$message.success("标记状态完成");

        this.abnormalOrderManualSetLoading = false;

        this.dialogFormVisible = false;

        this.getTable();
      },
      () => {
        this.abnormalOrderManualSetLoading = false;
      }
    );
  }



  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

}
